import axios from '@/axios'

const home = {

  async getFundsInfo(params = {}) {
    return await axios.post('/uc/user/userinfo/info', params, { des: '直客wap获取资金信息', sTime: new Date().getTime() })
  },

  async getRebate(params = {}) {
    return await axios.post('/uc/index/data', params, { des: '直客wap获取获取佣金详情', sTime: new Date().getTime() })
  },

}

export default home


// WEBPACK FOOTER //
// ./src/api/home.js